import axios from 'axios'
import React, { createContext, useEffect, useState, useRef, useCallback } from 'react'
import { useNavigate } from 'react-router-dom';
import baseUrl from '../BaseURL';


export const ContextData = createContext()
      
function Context({children}) {


    const navigate = useNavigate();
    const navigateRef = useRef(navigate);
    navigateRef.current = navigate;



    const [accesstoken,setaccesstoken] = useState(null)
    const [authReady, setAuthReady] = useState(false)
    const [authError, setAuthError] = useState(null)
    const [loggingOut, setLoggingOut] = useState(false)
    const authGeneration = useRef(0)
    const logoutPending = useRef(false)
    const channel = useRef(null)
    const [LoaderPercent,setLoaderPercent] = useState()
    const [Refresh,setRefresh] = useState(false)
    const [RefreshAmount,setRefreshAmount] = useState(false)
    const [Person,setPerson] = useState(null)
    const [profileError, setProfileError] = useState(null)
    const [UserToken,setUserToken] = useState("")
    const [compressedImage,setCompressedImage] = React.useState("");
    const [compressedNINImage,setCompressedNINImage] = React.useState("");
    const [SortValue,setSortValue] = useState(0)
    const [ID_ref_Num,setID_ref_Num] = useState("")
    const [MemberDataIDCard,setMemberDataIDCard] = useState(null)
    const [firstSlot,setfirstSlot] = useState("")
    const [secondSlot,setsecondSlot] = useState("")
    const [profileData, setProfileData] = useState(null);
    const [profileData2, setProfileData2] = useState(null);
    const [fetch,setfetch]  = useState("not")
    
   /*  const [issuance,setissuance] = useState({
        state:"Kaduna",
        issuDate:"10-08-2024",
        expiry:"10-08-2028"
    }) */
  
    const [issuance, setissuance] = useState(() => {
      const currentDate = new Date(); // Get current date
      const expiryDate = new Date(currentDate);
      expiryDate.setFullYear(currentDate.getFullYear() + 4); // Add 4 years to current date
      
      return {
          state: "Kaduna",
          issuDate: currentDate.toISOString().split("T")[0], // Format to YYYY-MM-DD
          expiry: expiryDate.toISOString().split("T")[0], // Format to YYYY-MM-DD
      };
  });

    const [Dep_and_post,setDep_and_post] = useState({

         department:"",
         position: ""
         
    })



// Get the signed-in user's profile only when authentication is available.
useEffect(() => {
  if (!UserToken || !accesstoken) {
    setPerson(null);
    setProfileError(null);
    return;
  }

  let cancelled = false;
  setProfileError(null);

  async function fetchProfile() {
    try {
      const response = await axios.get(`${baseUrl}/auth/get_single_data_user/${UserToken}`, {
        withCredentials: true,
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'authorization': `Bearer ${accesstoken}`
        }
      });
      const profile = Array.isArray(response.data) ? response.data[0] : null;
      if (!cancelled) {
        const validProfile = profile && typeof profile === 'object' && !Array.isArray(profile);
        setPerson(validProfile ? profile : null);
        setProfileError(validProfile ? null : 'Your account profile could not be found. Please sign in again.');
      }
    } catch (err) {
      if (!cancelled) {
        setPerson(null);
        setProfileError('Your account profile could not be loaded. Please sign in again.');
        console.log(err.message);
      }
    }
  }

  fetchProfile();
  return () => { cancelled = true; };
}, [UserToken, accesstoken]);

// Restore before protected routes decide whether to redirect. A network failure
// remains retryable instead of pretending that the user has signed out.
const clearAuthentication = useCallback(() => {
  authGeneration.current++;
  setaccesstoken(null); setUserToken(''); setPerson(null);
  setProfileError(null); setAuthError(null); setAuthReady(true);
  setCompressedImage(''); setCompressedNINImage('');
  setMemberDataIDCard(null); setProfileData(null); setProfileData2(null);
  setfirstSlot(''); setsecondSlot(''); setID_ref_Num('');
}, []);

const completeLogin = useCallback(data => {
  authGeneration.current++;
  setPerson(null); setProfileError(null); setAuthError(null);
  setaccesstoken(data.accesstoken); setUserToken(data.token); setAuthReady(true);
}, []);

const restoreAuthentication = useCallback(async () => {
  const generation = ++authGeneration.current;
  setAuthReady(false); setAuthError(null);
  try {
    const { data } = await axios.get(`${baseUrl}/free/refreshtokens`, { withCredentials: true, timeout: 15000 });
    if (generation !== authGeneration.current) return;
    if (data?.status === true && typeof data.accesstoken === 'string' && data.accesstoken && typeof data.token === 'string' && data.token) {
      setaccesstoken(data.accesstoken); setUserToken(data.token); setAuthReady(true);
    } else { clearAuthentication(); }
  } catch (error) {
    if (generation !== authGeneration.current) return;
    if ([401, 403].includes(error.response?.status)) clearAuthentication();
    else setAuthError('We could not restore your sign-in. Check your connection and retry.');
  }
}, [clearAuthentication]);

const logout = useCallback(async () => {
  if (logoutPending.current) return;
  logoutPending.current = true; setLoggingOut(true);
  // Prevent an older refresh response from restoring credentials during logout.
  authGeneration.current++;
  try {
    await axios.post(`${baseUrl}/free/logout`, {}, { withCredentials: true, timeout: 15000 });
    clearAuthentication();
    channel.current?.postMessage('logout');
    navigateRef.current('/login', { replace: true });
  } catch {
    // Keep the controls available to retry if server revocation did not succeed.
    throw new Error('Sign-out could not be completed. Check your connection and retry.');
  } finally { logoutPending.current = false; setLoggingOut(false); }
}, [clearAuthentication]);

useEffect(() => {
  void restoreAuthentication();
  const expired = () => { clearAuthentication(); navigateRef.current('/login', { replace: true }); };
  window.addEventListener('fin-auth-expired', expired);
  const broadcast = typeof BroadcastChannel === 'function' ? new BroadcastChannel('fin-auth') : null;
  channel.current = broadcast;
  if (broadcast) broadcast.onmessage = event => { if (event.data === 'logout') expired(); };
  return () => {
    authGeneration.current++;
    window.removeEventListener('fin-auth-expired', expired);
    broadcast?.close(); channel.current = null;
  };
}, [restoreAuthentication, clearAuthentication]);

  return (
    <ContextData.Provider
    value={{
      accesstoken,setaccesstoken,
      authReady,authError,restoreAuthentication,completeLogin,logout,loggingOut,
      LoaderPercent,setLoaderPercent,
      Refresh,setRefresh,
      UserToken,setUserToken,
      Person,setPerson,
      profileError,
      compressedImage,setCompressedImage,
      compressedNINImage,setCompressedNINImage,
      RefreshAmount,setRefreshAmount,
      SortValue,setSortValue,
      ID_ref_Num,setID_ref_Num,
      issuance,setissuance,
      Dep_and_post,setDep_and_post,
      MemberDataIDCard,setMemberDataIDCard,
      firstSlot,setfirstSlot,
      secondSlot,setsecondSlot,
      profileData,setProfileData,
      profileData2,setProfileData2,
      fetch,setfetch
      
    } }
    > 
    {children}
    
    </ContextData.Provider>
  )
}

export default Context